/**
 * D-Wishlist — localStorage-based wishlist with delegated click handling.
 * Buttons must have: data-wishlist, data-wishlist-handle="<handle>", data-product-id="<id>"
 * Active state: .wishlist-added class toggled on the button.
 * Count badges: any element with [data-wishlist-count] gets its textContent updated.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'wishlistItem';

  /* ── Storage helpers ─────────────────────────────────────── */

  function getItems() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (_) {
      return [];
    }
  }

  function saveItems(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (_) {
      /* quota exceeded — silently ignore */
    }
  }

  function hasItem(handle) {
    return getItems().indexOf(handle) !== -1;
  }

  function addItem(handle) {
    var items = getItems();
    if (items.indexOf(handle) === -1) {
      items.push(handle);
      saveItems(items);
      document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { action: 'add', handle: handle } }));
    }
    return items;
  }

  function removeItem(handle) {
    var items = getItems();
    var idx = items.indexOf(handle);
    if (idx > -1) {
      items.splice(idx, 1);
      saveItems(items);
      document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { action: 'remove', handle: handle } }));
    }
    return items;
  }

  /* ── DOM helpers ──────────────────────────────────────────── */

  function updateCount() {
    var count = getItems().length;
    var els = document.querySelectorAll('[data-wishlist-count]');
    for (var i = 0; i < els.length; i++) {
      els[i].textContent = String(count);
    }
  }

  function syncButtons() {
    var items = getItems();
    var buttons = document.querySelectorAll('[data-wishlist]');
    for (var i = 0; i < buttons.length; i++) {
      var handle = buttons[i].getAttribute('data-wishlist-handle');
      if (handle && items.indexOf(handle) !== -1) {
        buttons[i].classList.add('wishlist-added');
      } else {
        buttons[i].classList.remove('wishlist-added');
      }
    }
    updateCount();
  }

  /* ── Click handler (delegated) ───────────────────────────── */

  function handleClick(e) {
    var button = e.target.closest('[data-wishlist]');
    if (!button) return;

    e.preventDefault();
    e.stopPropagation();

    var handle = button.getAttribute('data-wishlist-handle');
    if (!handle) return;

    if (button.classList.contains('wishlist-added')) {
      removeItem(handle);
      button.classList.remove('wishlist-added');

      /* If we're on the wishlist page, remove the card from DOM */
      var productId = button.getAttribute('data-product-id');
      var container = document.querySelector('[data-wishlist-container]');
      if (container && productId) {
        var card = document.querySelector('[data-wishlist-added="wishlist-' + productId + '"]');
        if (card) {
          var parent = card.closest('.product') || card;
          parent.remove();
        }
        if (getItems().length === 0) {
          showEmptyState(container);
        }
      }
    } else {
      addItem(handle);
      button.classList.add('wishlist-added');
    }

    updateCount();
  }

  function showEmptyState(container) {
    var cfg = window.wishlist || {};
    var emptyText = cfg.empty || 'Sua lista de desejos está vazia';
    var continueText = cfg.continue_shopping || 'Continuar comprando';
    var url = (window.routes && window.routes.collection_all) || '/collections/all';

    container.classList.add('is-empty');
    container.innerHTML =
      '<div class="wishlist-content-empty text-center">' +
        '<span class="wishlist-content-text">' + emptyText + '</span>' +
        '<div class="wishlist-content-actions">' +
          '<a class="button button-2 button-continue" href="' + url + '">' + continueText + '</a>' +
        '</div>' +
      '</div>';

    var footer = document.querySelector('[data-wishlist-footer]');
    if (footer) footer.style.display = 'none';
  }

  /* ── Init ─────────────────────────────────────────────────── */

  function init() {
    syncButtons();
    document.addEventListener('click', handleClick);

    /* Re-sync after Shopify section JS events (theme editor, section rendering) */
    document.addEventListener('shopify:section:load', syncButtons);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Expose for external use (wishlist page, header count, etc.) */
  window.DWishlist = {
    getItems: getItems,
    hasItem: hasItem,
    addItem: addItem,
    removeItem: removeItem,
    syncButtons: syncButtons,
    updateCount: updateCount
  };
})();
